import { ObjectLeftIcon } from "../icons/objectsTable/objectsType/ObjectLeftIcon"
import { ObjectRightIcon } from "../icons/objectsTable/objectsType/ObjectRightIcon"
import { ObjectShelvesIcon } from "../icons/objectsTable/objectsType/ObjectShelvesIcon"
import { ObjectWholeIcon } from "../icons/objectsTable/objectsType/ObjectWholeIcon"
import { ObjectCompositeIcon } from "../icons/objectsTable/objectsType/ObjectCompositeIcon"
import { ObjectColumnBasedIcon } from "../icons/objectsTable/objectsType/ObjectColumnBasedIcon"
import type { TObjectsType } from "types/configuration.type"

type Props = { type: TObjectsType }

export const ConfigurationsObjectsType = ({ type }: Props) => {
	switch (type) {
		case "left_part_of_dual_object":
			return (
				<div data-testid="leftIcon">
					<ObjectLeftIcon />
				</div>
			)
		case "right_part_of_dual_object":
			return (
				<div data-testid="rightIcon">
					<ObjectRightIcon />
				</div>
			)
		case "whole_dual_object":
			return (
				<div data-testid="wholeIcon">
					<ObjectWholeIcon />
				</div>
			)
		case "shelves_object":
			return (
				<div data-testid="shelvesIcon">
					<ObjectShelvesIcon />
				</div>
			)
		case "composite_object":
			return (
				<div data-testid="compositeIcon">
					<ObjectCompositeIcon />
				</div>
			)
		case "column_based_object":
			return (
				<div data-testid="columnBasedIcon">
					<ObjectColumnBasedIcon />
				</div>
			)
	}
}
